import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { CSSGrid } from '../css-grid/css-grid';
import classnames from 'classnames';
import styles from './page-list.scss';
export class PageList extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "renderPage", (items, pageNumber) => {
      const {
        isRTL,
        numberOfRows,
        numberOfColumns,
        gridMinWidth,
        styleId,
        gridId
      } = this.props;
      const canUseCssGrid = numberOfRows && numberOfColumns && gridMinWidth && styleId;
      const pageStyles = classnames({
        [styles.page]: !canUseCssGrid,
        [styles.rtl]: isRTL,
        [styles.ltr]: !isRTL
      });
      const pageItems = this.renderPageItems(items, pageNumber);
      return /*#__PURE__*/React.createElement("div", {
        key: pageNumber,
        "data-hook": "page-list-page",
        className: pageStyles,
        style: {
          minWidth: this.props.pageWidth || '100vw'
        }
      }, pageItems && canUseCssGrid ? /*#__PURE__*/React.createElement(CSSGrid, {
        gridId: gridId,
        styleId: styleId,
        rows: numberOfRows,
        cols: numberOfColumns,
        style: {
          minWidth: gridMinWidth
        }
      }, pageItems) : pageItems);
    });
  }
  shouldRenderPage(pageNumber) {
    const {
      currentPageNumber,
      preRenderedCount
    } = this.props;
    return Math.abs(currentPageNumber - pageNumber) <= preRenderedCount;
  }
  renderPageItems(itemIds, pageNumber) {
    const {
      renderItem,
      currentPageNumber
    } = this.props;
    const isVisiblePage = pageNumber === currentPageNumber;
    return this.shouldRenderPage(pageNumber) ? itemIds.map((itemId, itemIndexAtPage) => renderItem(itemId, itemIndexAtPage, isVisiblePage)) : null;
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.container
    }, this.props.itemsByPageNumber.map(this.renderPage));
  }
}
_defineProperty(PageList, "defaultProps", {
  preRenderedCount: 1
});
//# sourceMappingURL=page-list.js.map